export default __webpack_public_path__ + "static/media/post-meeting-wave-background.fed2c029.svg";